<template>
    <div v-if="isShow" class="travellingDiary__scrollTop">
        <p class="font-bold">将文本分享至</p>
        <a href="javascript: void(0)" class="shareQQ" @click="shareQQ(localShareUrl, shareText, shareImage, localShareTitle, shareDesc)">
            <img src="../../assets/qZone.png">
        </a>
        <a href="javascript: void(0)" class="shareWeibo" @click="shareSinaWeibo(localShareUrl, shareText, shareImage)">
            <img src="../../assets/weibo.png">
        </a>
        <a href="javascript: void(0)" class="wechat_link">
            <div class="qr_container">
                <img class="qrcode" :src="localQrCode" alt="">
                <p>扫描上方二维码，分享到朋友圈</p>
            </div>
            <img src="../../assets/wechat.png">
        </a>
        <a href="javascript: void(0)" class="go-top" @click="goTop">
            <img src="../../assets/scrollTop.png">
        </a>
    </div>
</template>

<script>
    export default {
        name: 'EmailShare',
        props: {
            isShow: {
                type: Boolean,
                default: false,
            },
            qrCode: {
                type: String,
                default: '',
            },
            shareUrl: {
                type: String,
                default: '',
            },
            shareText: {
                type: String,
                default: '',
            },
            shareImage: {
                type: String,
                default: '',
            },
            shareTitle: {
                type: String,
                default: '',
            },
            shareDesc: {
                type: String,
                default: '',
            }
        },
        data () {
            return {
                localQrCode: '',
                localShareUrl: '',
                localShareTitle: '',
            }
        },
        watch: {
            shareUrl (newVal) {
                this.localShareUrl = newVal
            },
            qrCode (newVal) {
                this.localQrCode = newVal
            },
            shareTitle (newVal) {
                this.localShareTitle = newVal
            }
        },
        methods: {
            goTop () {
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                })
            },
            shareSinaWeibo (shareUrl, shareText, shareImage) {
                window.open(`http://service.weibo.com/share/share.php?url=${shareUrl}&title=${encodeURIComponent(shareText)}&pic=${shareImage}&searchPic=false`, '_blank', 'width=600,height=550')
            },
            shareTXWeibo (shareUrl, shareText, shareImage) {
                window.open(`http://v.t.qq.com/share/share.php?url=${shareUrl}&site=${shareUrl}&title=${encodeURIComponent(shareText)}&pic=${shareImage}`, '_blank', 'width=600,height=550')
            },
            shareDouban (shareUrl, shareText, shareImage, shareTitle) {
                window.open(`http://www.douban.com/share/service?image=${shareImage}&href=${shareUrl}&name=${shareTitle}&text=${encodeURIComponent(shareText)}`, '_blank', 'width=600,height=550')
            },
            shareKaixin (shareUrl, shareText, shareImage) {
                window.open(`http://www.kaixin001.com/rest/records.php?url=${shareUrl}&site=${shareUrl}&content=${encodeURIComponent(shareText)}&url=${location.href}&starid=&aid=0&style=11&pic=${shareImage}&site=${location.href}`, '_blank', 'width=600,height=550')
            },
            shareRenren (shareUrl, shareText, shareImage, shareTitle) {
                window.open(`http://widget.renren.com/dialog/share?resourceUrl=${shareUrl}&srcUrl${shareUrl}&title=${encodeURIComponent(shareTitle)}&images=${shareImage}&description=${encodeURIComponent(shareText)}`, '_blank', 'width=600,height=550')
            },
            shareQQ (shareUrl, shareText, shareImage, shareTitle, shareDesc) {
                window.open(`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}&pics=${shareImage}&summary=${encodeURIComponent(shareText)}&desc=${encodeURIComponent(shareDesc)}`, '_blank', 'width=600,height=550')
            },
        },
    }
</script>

<style lang="less" scoped>
    /*滑动到顶部*/
    .travellingDiary__scrollTop{
        position: fixed;
        width: 48px;
        top: 155px;
        right: 38px;
        text-align: center;
        z-index:222;
    }
    .travellingDiary__scrollTop p {
        font-size: 13px;
        color: #666;
    }

    .travellingDiary__scrollTop a{
        display: inline-block;
        border-radius: 4px;
        overflow: hidden;
    }

    .travellingDiary__scrollTop img{
        width:48px;
        height:48px;
    }
    .travellingDiary__scrollTop .qr_container:before {
        position: absolute;
        top: 20px;
        border-color: transparent;
        border-style: solid;
        content: "";
        margin-left: -5px;
        border-top: 8px solid transparent;
        border-left: 8px solid;
        border-bottom: 8px solid transparent;
        color: #fff;
        right: -10px;
    }

    .travellingDiary__scrollTop .qr_container {
        display: none;
        position: fixed;
        top: 304px;
        right: 100px;
        width: 207px;
        height: 207px;
        background-color: #fff;
    }

    .travellingDiary__scrollTop .qr_container .qrcode{
        margin: 20px 0 15px 0;
        width: 140px;
        height: 140px;
    }
    .wechat_link:hover .qr_container {
        display: block;
    }
</style>
